(function () {
  'use strict';

  // Only run on the store-locator page
  if (window.location.pathname.indexOf('/pages/store-locator') === -1) return;

  var DISTANCE_THRESHOLD = 20;
  var WALMART_INSOLE_URL = 'https://www.walmart.com/ip/Kids-Low-Arch-Support-for-Children-Suffering-from-Flat-feet-Foot-Pain-and-Heel-Pain-Kids-Shoe-Size-12-2-5/17522759489';
  var WALMART_HEEL_URL = 'https://www.walmart.com/ip/All-Purpose-Heel-Cup-Heel-Pain-Relief-for-Active-Kids-Kids-Shoe-size-11-2-5/17802064335';

  var modalShownThisSearch = false;
  var lastSearchedZip = null; // ← NEW

  // ── GA4 Walmart Modal Tracking ─────────────────────────────────────────────
  function trackModalEvent(eventName) {
    try {
      if (typeof gtag === 'function') {
        gtag('event', eventName, {
          event_category: 'walmart_modal',
          event_label: 'store_locator',
          search_zip: lastSearchedZip || 'unknown' // ← NEW
        });
      }
    } catch (e) {}
  }
  // ──────────────────────────────────────────────────────────────────────────

  function removeModal() {
    var existing = document.getElementById('ks-walmart-modal-overlay');
    if (existing) existing.parentNode.removeChild(existing);
  }

  function createModal(distance) {
    removeModal();

    // GA4: Modal viewed
    trackModalEvent('modal_viewed');

    var overlay = document.createElement('div');
    overlay.id = 'ks-walmart-modal-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'ks-modal-heading');
    overlay.style.cssText = [
      'position:fixed',
      'inset:0',
      'z-index:999999',
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'background:rgba(0,0,0,0.52)',
      'padding:16px',
      'box-sizing:border-box',
      'animation:ksFadeIn 0.22s ease'
    ].join(';');

    var card = document.createElement('div');
    card.style.cssText = [
      'background:#fff',
      'border-radius:14px',
      'box-shadow:0 8px 40px rgba(0,0,0,0.18)',
      'max-width:480px',
      'width:100%',
      'padding:32px 28px 28px',
      'position:relative',
      'box-sizing:border-box',
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif',
      'animation:ksSlideUp 0.25s ease'
    ].join(';');

    // Close button
    var closeBtn = document.createElement('button');
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '&times;';
    closeBtn.style.cssText = [
      'position:absolute',
      'top:14px',
      'right:16px',
      'background:none',
      'border:none',
      'font-size:24px',
      'line-height:1',
      'color:#888',
      'cursor:pointer',
      'padding:4px 8px',
      'border-radius:6px',
      'transition:color 0.15s,background 0.15s'
    ].join(';');
    closeBtn.addEventListener('mouseenter', function () {
      closeBtn.style.color = '#333';
      closeBtn.style.background = '#f4f4f4';
    });
    closeBtn.addEventListener('mouseleave', function () {
      closeBtn.style.color = '#888';
      closeBtn.style.background = 'none';
    });
    closeBtn.addEventListener('click', function () {
      modalShownThisSearch = true;
      // GA4: Modal dismissed via close button
      trackModalEvent('modal_dismissed');
      removeModal();
    });

    // Walmart accent bar
    var accentBar = document.createElement('div');
    accentBar.style.cssText = [
      'height:4px',
      'background:linear-gradient(90deg,#0071ce 0%,#ffc220 100%)',
      'border-radius:4px',
      'margin-bottom:20px'
    ].join(';');

    // Heading
    var heading = document.createElement('h2');
    heading.id = 'ks-modal-heading';
    heading.style.cssText = 'margin:0 0 6px;font-size:16px;font-weight:700;color:#1a1a2e;line-height:1.3;';
    heading.appendChild(document.createTextNode('Unfortunately, the nearest retailer to you is '));
    var distanceSpan = document.createElement('span');
    distanceSpan.textContent = Math.round(distance) + ' miles';
    distanceSpan.style.cssText = 'color:#e00;font-size:16px;font-weight:700;';
    heading.appendChild(distanceSpan);
    heading.appendChild(document.createTextNode(' away.'));

    var subheading = document.createElement('p');
    subheading.textContent = 'Order directly from Walmart.com';
    subheading.style.cssText = [
      'margin:0 0 22px',
      'font-size:15px',
      'color:#0071ce',
      'font-weight:600'
    ].join(';');

    // Divider
    var divider = document.createElement('hr');
    divider.style.cssText = [
      'border:none',
      'border-top:1px solid #f0f0f0',
      'margin:0 0 20px'
    ].join(';');

    // Products label
    var productsLabel = document.createElement('p');
    productsLabel.textContent = 'Shop KidSole products on Walmart:';
    productsLabel.style.cssText = [
      'margin:0 0 14px',
      'font-size:13px',
      'font-weight:600',
      'color:#555',
      'text-transform:uppercase',
      'letter-spacing:0.5px'
    ].join(';');

    // Button helper
    function makeProductBtn(label, url, isPrimary) {
      var btn = document.createElement('a');
      btn.href = url;
      btn.target = '_blank';
      btn.rel = 'noopener noreferrer';
      btn.textContent = label;
      btn.style.cssText = [
        'display:block',
        'width:100%',
        'box-sizing:border-box',
        'padding:13px 16px',
        'border-radius:8px',
        'font-size:14px',
        'font-weight:600',
        'text-align:center',
        'text-decoration:none',
        'cursor:pointer',
        'transition:opacity 0.15s,transform 0.1s',
        isPrimary
          ? 'background:#0071ce;color:#fff;border:2px solid #0071ce'
          : 'background:#0071ce;color:#fff;border:2px solid #0071ce'
      ].join(';');
      btn.addEventListener('mouseenter', function () {
        btn.style.opacity = '0.88';
        btn.style.transform = 'translateY(-1px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.opacity = '1';
        btn.style.transform = 'none';
      });
      // GA4: Walmart link clicked
      btn.addEventListener('click', function () {
        trackModalEvent('walmart_link_clicked');
      });
      return btn;
    }

    var btnStack = document.createElement('div');
    btnStack.style.cssText = 'display:flex;flex-direction:column;gap:10px';

    var insoleBtn = makeProductBtn('Kids Low Arch Support Insole', WALMART_INSOLE_URL, true);
    var heelBtn = makeProductBtn('All Purpose Heel Cup', WALMART_HEEL_URL, false);

    btnStack.appendChild(insoleBtn);
    btnStack.appendChild(heelBtn);

    // Footer note
    var footerNote = document.createElement('p');
    footerNote.textContent = 'Ships directly from Walmart — fast & free on qualifying orders.';
    footerNote.style.cssText = [
      'margin:18px 0 0',
      'font-size:12px',
      'color:#999',
      'text-align:center'
    ].join(';');

    // Keyframe styles injected into the MAIN document
    if (!document.getElementById('ks-modal-styles')) {
      var styleEl = document.createElement('style');
      styleEl.id = 'ks-modal-styles';
      styleEl.textContent = [
        '@keyframes ksFadeIn{from{opacity:0}to{opacity:1}}',
        '@keyframes ksSlideUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}'
      ].join('');
      document.head.appendChild(styleEl);
    }

    card.appendChild(closeBtn);
    card.appendChild(accentBar);
    card.appendChild(heading);
    card.appendChild(subheading);
    card.appendChild(divider);
    card.appendChild(productsLabel);
    card.appendChild(btnStack);
    card.appendChild(footerNote);
    overlay.appendChild(card);

    // Close on overlay click (outside card)
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        modalShownThisSearch = true;
        // GA4: Modal dismissed via overlay click
        trackModalEvent('modal_dismissed');
        removeModal();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function escHandler(e) {
      if (e.key === 'Escape') {
        modalShownThisSearch = true;
        // GA4: Modal dismissed via Escape key
        trackModalEvent('modal_dismissed');
        removeModal();
        document.removeEventListener('keydown', escHandler);
      }
    });

    document.body.appendChild(overlay);
  }

  // ── Fetch interception ─────────────────────────────────────────────────────
  var originalFetch = window.fetch;

  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) ? input.url : String(input);

    var isStockistSearch = url.indexOf('stockist') !== -1 && url.indexOf('searches') !== -1;

    if (isStockistSearch) {
      modalShownThisSearch = false;

      try {
        var questionMark = url.indexOf('?');
        if (questionMark !== -1) {
          var queryString = url.slice(questionMark + 1);
          var params = queryString.split('&');
          var eventParam = null;
          for (var i = 0; i < params.length; i++){
            var pair = params[i].split('=');
            if (pair[0] === 'event') {
              eventParam = decodeURIComponent(pair[1]);
              break;
            }
          }

          // ── Extract zip code from URL ── NEW
          for (var j = 0; j < params.length; j++) {
            var p = params[j].split('=');
            if (p[0] === 'address' || p[0] === 'zip' || p[0] === 'query') {
              lastSearchedZip = decodeURIComponent(p[1] || '').trim();
              break;
            }
          }
          // ─────────────────────────────

          if (eventParam) {
            var decoded = atob(eventParam);
            var parsed = JSON.parse(decoded);
            var nearest = parsed && parsed.results && parsed.results.nearest;
            if (nearest && nearest.length > 0) {
              var distance = nearest[0].distance;
              if (typeof distance === 'number' && !isNaN(distance) && distance > DISTANCE_THRESHOLD) {
                modalShownThisSearch = true;
                createModal(distance);
              }
            }
          }
        }
      } catch (e) {
        // Parsing failed — fall through silently
      }
    }

    return originalFetch.apply(this, arguments);
  };

})();
